module.exports = __webpack_public_path__ + "img/item-3.72a95fd.png";